import { BaseSearchDTO } from "../../../../../uinspect/src/app/global/interfaces";

export interface UInspectAnswerSearchDTO extends BaseSearchDTO {
  filters?: {
    id: number,
  };
}
